import { CMS_IMAGE_SPECS, CMS_ICON_SPECS } from "../../lib/cmsMediaSpecs";

function SpecCard({ label, children }) {
  return (
    <li className="rounded-2xl bg-[#f8faf9] border border-brand-soft/70 px-3 py-2.5">
      <p className="text-[10px] font-bold uppercase tracking-widest text-brand-dark/45 mb-0.5">
        {label}
      </p>
      <div className="text-xs text-brand-dark/75 leading-snug">{children}</div>
    </li>
  );
}

const VARIANT_COPY = {
  icons: {
    title: "Especificaciones de iconos",
    items: [
      { label: "Formato", body: CMS_ICON_SPECS.formatsLabel },
      {
        label: "Tamaño",
        body: (
          <>
            <strong>{CMS_ICON_SPECS.sizeLabel}</strong>
            <p className="text-[11px] text-brand-dark/50 mt-0.5">En el sitio: 36–64 px</p>
          </>
        ),
      },
      { label: "Peso", body: CMS_ICON_SPECS.weightLabel },
      {
        label: "Preferido",
        body: `${CMS_ICON_SPECS.preferredSize}×${CMS_ICON_SPECS.preferredSize} px, fondo transparente`,
      },
    ],
  },
  images: {
    title: "Especificaciones de imágenes",
    items: [
      { label: "Formato", body: CMS_IMAGE_SPECS.formatsLabel },
      { label: "Tamaño", body: CMS_IMAGE_SPECS.sizeHint },
      { label: "Peso", body: CMS_IMAGE_SPECS.weightLabel },
    ],
  },
  logos: {
    title: "Especificaciones de logos",
    items: [
      { label: "Formato", body: "PNG o SVG con fondo transparente" },
      { label: "Tamaño", body: "200–400 px de ancho recomendado" },
      { label: "Peso", body: CMS_IMAGE_SPECS.weightLabel },
    ],
  },
};

/**
 * Columna izquierda de specs, junto al bloque de campos que las usan.
 * @param {"icons"|"images"|"logos"} variant
 */
export function CmsMediaSpecsPanel({ variant = "icons", sticky = true }) {
  const copy = VARIANT_COPY[variant] || VARIANT_COPY.icons;
  return (
    <aside className={`${sticky ? "lg:sticky lg:top-6" : ""} space-y-3`}>
      <div className="bg-white rounded-2xl border border-brand-soft p-4 space-y-3">
        <h4 className="font-bold text-sm leading-tight">{copy.title}</h4>
        <ul className="space-y-2">
          {copy.items.map((item) => (
            <SpecCard key={item.label} label={item.label}>
              {item.body}
            </SpecCard>
          ))}
        </ul>
      </div>
    </aside>
  );
}

/**
 * Layout: especificaciones a la izquierda del contenido media correspondiente.
 */
export default function CmsWithMediaSpecs({ variant = "icons", sticky = true, children }) {
  return (
    <div className="grid lg:grid-cols-[200px_minmax(0,1fr)] gap-4 items-start">
      <CmsMediaSpecsPanel variant={variant} sticky={sticky} />
      <div className="min-w-0 space-y-4">{children}</div>
    </div>
  );
}
